// extracted by mini-css-extract-plugin
export default {"PayChannelRadio":"DeliveryPayContent_PayChannelRadio__ZzWtX","ant-radio":"DeliveryPayContent_ant-radio__5BZrm","icon":"DeliveryPayContent_icon__zpqQK"};